import styles from "./TippingJourneyLayout.module.scss";
import tippingLogo from "../../assests/tipperLogo.svg";

interface Step {
    id: string;
    title: string;
    subtitle: string;
}

interface Props {
    steps: Step[];
    activeStep: number;
    maxStepReached: number;
    onStepClick?: (stepIndex: number) => void;
    children: React.ReactNode;
    footer?: React.ReactNode;
}

const TippingJourneyLayout = ({
    steps,
    activeStep,
    maxStepReached,
    onStepClick,
    children,
    footer,
}: Props) => {
    const renderStepIndicator = (index: number) => {
        if (index < activeStep) {
            return (
                <span className={`${styles.stepIndex} ${styles.completedIndex}`}>
                    <svg
                        width="16"
                        height="12"
                        viewBox="0 0 16 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1.5 6L5.5 10L14.5 1"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </span>
            );
        }

        if (index === activeStep) {
            return (
                <span className={`${styles.stepIndex} ${styles.activeIndex}`}>
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M4 7H10"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                        />
                        <path
                            d="M7.5 4.5L10 7L7.5 9.5"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </span>
            );
        }

        return <span className={styles.stepIndex} />;
    };

    return (
        <div className={styles.wrapper}>
            <aside className={styles.sidePanel}>
                <div>
                    <span className={styles.brandTag}><img src={tippingLogo} alt="" /></span>
                    <div className={styles.sidePanelTitleContainer}>
                        <h4 className={styles.sidePanelTitle}>Welcome to</h4>
                        <h2>TopTipper!</h2>
                    </div>

                    <ol className={styles.stepList}>
                        {steps.map((step, index) => {
                            const isClickable = index <= maxStepReached;
                            const isDisabled = !isClickable;

                            return (
                                <li
                                    key={step.id}
                                    className={[
                                        activeStep === index ? styles.active : "",
                                        index < activeStep ? styles.completed : "",
                                        isClickable ? styles.clickable : styles.disabled,
                                    ].join(" ")}
                                    onClick={() => isClickable && onStepClick?.(index)}
                                >
                                    {renderStepIndicator(index)}
                                    <div>
                                        <p>{step.title}</p>
                                        <span>{step.subtitle}</span>
                                    </div>
                                </li>
                            );
                        })}
                    </ol>
                </div>
                <p className={styles.supportText}>
                    For help at any time, message us at{" "}
                    <a href="mailto:support@toptipper.co">support@toptipper.co</a>
                </p>
            </aside>
            <section className={styles.content}>
                {children}
                {footer && <div className={styles.footer}>{footer}</div>}
            </section>
        </div>
    );
};

export default TippingJourneyLayout;

